import React from 'react';
import image from '../../../assets/ImagesSuggestions/img-ingredient-suggestion.png';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const  IngredientSuggestions = () => {

    return (<div className='row'>
        <div className='col-12 d-flex justify-content-center align-items-center text-center'>
            <img src={image} alt='add' />
        </div>
    </div>)

}

export  default IngredientSuggestions;
